import { Tabs as TabsAnt } from 'antd';
import styled from 'styled-components';

export const Tabs = styled(TabsAnt)`
	.ant-tabs-nav {
		margin-bottom: 1.5rem;
	}
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 1.5rem;
	padding-top: 1rem;
`;

export const FooterActions = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;
